import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import type { ShippingFormFields } from "@jti/commerce-types";
import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useFormContext, useTranslations } from "@jti/ui";

import type { SharedSectionsProps } from "@checkout-v2/features/DeliveryInformation/DeliveryAddresses/DeliveryAddresses.types";
import { OrderAttributesSlot } from "@checkout-v2/features/OrderAttributes";
import { BillingAddressField } from "@checkout-v2/formFields/components/BillingAddressField";

import styles from "./NonAtHomeBillingAddresses.module.scss";

export const NonAtHomeBillingAddresses: FC<SharedSectionsProps> = ({
  formFieldsConfig,
  billingAddressCardRef,
  showBillingValidationError = false,
}) => {
  const config = useConfig();
  const { __ } = useTranslations();
  const form = useFormContext<ShippingFormFields>();

  const isBillingAddressSameAsShippingFieldValue = form.watch(formFieldsConfig.isBillingAddressSameAsShipping.name);
  const defaultBillingAddress = formFieldsConfig.billingAddress.defaultAddress?.isDefaultBilling
    ? formFieldsConfig.billingAddress.defaultAddress
    : null;

  if (!config.isBillingAddressVisibleForCheckout) {
    return null;
  }

  return (
    <div ref={billingAddressCardRef} data-testid="delivery-addresses-non-at-home-billing-section">
      {showBillingValidationError && (
        <AlertBanner tone="warning" description={__("cart.checkout.warning.billing_address_validation_description")} />
      )}

      <div className={styles.billingAddressAndAfterSlot}>
        <BillingAddressField
          fieldConfig={formFieldsConfig.billingAddress}
          initialMode={defaultBillingAddress ? "view" : "custom"}
          address={defaultBillingAddress}
          formTitle={__("cart.billing.title")}
          beforeSlot={<OrderAttributesSlot slotTarget="billingaddress_before" />}
        />

        {!isBillingAddressSameAsShippingFieldValue && <OrderAttributesSlot slotTarget="billingaddress_after" />}
      </div>
    </div>
  );
};
